module.exports = __webpack_public_path__ + "static/media/dirt.692e992e.jpg";